import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TopicService } from 'app/services/topic.service';
import {Source} from 'app/models/source.enum'
import { Topic } from 'app/models/topic';
import { ModalTopicComponent } from 'app/shared/components/modal-topic/modal-topic.component';
import { ColumnSortComponent } from 'app/shared/components/column-sort/column-sort.component';
import {AssetsFactory} from 'app/services/assets.factory.services'

@Component({
  selector: 'app-topics',
  templateUrl: './topics.component.html',
  styleUrls: ['./topics.component.scss']
})
export class TopicsComponent extends ColumnSortComponent implements OnInit {

  bsModalRef: BsModalRef;
  openContent: Array<string> = new Array();
  lastEvaluatedKey: any;

  constructor(private topicService: TopicService, private modalService: BsModalService, private assetsFactory: AssetsFactory) {
    super(assetsFactory);
    this.assetType = Source.Topic;
  }

  override ngOnInit() {
    this.getAll();
  }
ngOnDestroy(){
    if(this.bsModalRef)
     this.bsModalRef.content.close.unsubscribe();
}
  onAdd() {
    this.showModal(null, 'ADD TOPIC', 'ADD TOPIC');
  }

  onEdit(topic: Topic) {
    this.showModal(topic, 'EDIT TOPIC', 'SAVE TOPIC');
  }

  onDelete(topic: Topic) {
    this.topicService
      .delete(topic.id)
      .subscribe((topics) => this.getAll());
  }

  onContentState(data, state) {
    if (state) {
      this.openContent.push(data.id);
    } else {
      this.openContent = this.openContent.filter((c) => c !== data.id);
    }
  }

  isContentShow(id) {
    return this.openContent.some((c) => c === id);
  }

  onSave(topic: Topic) {
    this.topicService
      .update(topic)
      .subscribe((topics) => this.getAll());
  }

  getNext() {
    this.getAll(this.lastEvaluatedKey);
  }

  getAll(lastEvaluatedKey?: string): void {
    this.topicService
      .getAll(lastEvaluatedKey)
      .subscribe(data => {
        this.getListSorted(this.sort, this.direction).subscribe(r => {this.assets = r.Items});
        this.lastEvaluatedKey = data.LastEvaluatedKey;
      });
  }

  private showModal(topic: Topic, headerTitle: string, buttonTitle: string) {
    this.bsModalRef = this.modalService.show(ModalTopicComponent, {
      class: 'modal-lg',
      backdrop: 'static'
    });
    if (topic) {
      this.bsModalRef.content.topic = Object.assign({},topic);
    }
    this.bsModalRef.content.title = headerTitle;
    this.bsModalRef.content.buttonTitle = buttonTitle;

    this.bsModalRef.content.close.subscribe(() => {
      this.getAll();
      this.bsModalRef.hide();
       this.bsModalRef.content.close.unsubscribe();
    })
  }
}
